import React from 'react'
import { NavLink, useNavigate } from "react-router-dom";
import avatar from "../../assets/dashboard-avatar.png";

const Avatar = () => {
    const navigate = useNavigate();

    const handleClick = () => {
      navigate("/profile/:applicantId"); // Replace '/profile' with the actual path of the profile page
    };

  return (
    <NavLink to="/profile" onClick={handleClick}>
      <img src={avatar} alt="user avatar" />
    </NavLink>
  );
}

export default Avatar